/**
 * 抽象数据结构(ADT) -- 基类
 */

class BaseADT 
{
}

export default {
  BaseADT,
};



// WEBPACK FOOTER //
// ./src/foundation/adt/base/index.js